export const rawValue = (zone, field) => (
  Object.prototype.hasOwnProperty.call(zone, `${field}_raw`)
    ? zone[`${field}_raw`]
    : zone[field]
);

export default rawValue;
